// Paper sizes in millimetres (portrait). Orientation swaps width/height.
// `roll` = receipt (slip) printer paper: fixed width, no pages, height grows
// with the content (h is only a fallback for the preview).
export const PAPERS = {
  A3: { w: 297, h: 420 },
  A4: { w: 210, h: 297 },
  A5: { w: 148, h: 210 },
  A6: { w: 105, h: 148 },
  Letter: { w: 216, h: 279 },
  Legal: { w: 216, h: 356 },
  Label100x150: { w: 100, h: 150 }, // shipping label (thermal label printers)
  Roll80: { w: 80, h: 297, roll: true },
  Roll58: { w: 58, h: 297, roll: true },
};

export function isRoll(page) {
  return !!(PAPERS[page.size] && PAPERS[page.size].roll);
}

export function paperSize(page) {
  var p = page.size === 'custom'
    ? { w: Number(page.customW) || 210, h: Number(page.customH) || 297 }
    : PAPERS[page.size] || PAPERS.A4;
  if (p.roll) return { w: p.w, h: p.h, roll: true };
  return page.orientation === 'landscape' ? { w: p.h, h: p.w } : { w: p.w, h: p.h };
}

// Row heights (mm) per density; fixed height keeps pagination deterministic.
export const DENSITY = { compact: 5.6, normal: 7, comfortable: 8.6 };
